import { render, staticRenderFns } from "./ABTestConfiguration.vue?vue&type=template&id=fb7128a4&scoped=true"
import script from "./ABTestConfiguration.vue?vue&type=script&lang=js"
export * from "./ABTestConfiguration.vue?vue&type=script&lang=js"
import style0 from "./ABTestConfiguration.vue?vue&type=style&index=0&id=fb7128a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7128a4",
  null
  
)

export default component.exports